@if (studentInfoLoaded) {
  <div class="student-detail">
    <div class="info">
      <div class="student-info">
        <img class="avatar-image" data-cy="student-avator" [src]="student.avatar" />
        <div class="text-info">
          <p class="name" data-cy="student-name">{{ student.name }}</p>
          <p class="class-name" data-cy="student-class">{{ student.class_name }}{{ student.attendance_number }}番</p>
        </div>
      </div>
      <span class="number-stories">
        作成したストーリー：<a class="spen-util-link" data-cy="created-stories" routerLink="/stories/teacher/students/{{ student.id }}"
          >{{ student.number_stories }}/{{ MAX_NUMBER_STORIES }}</a
        >
      </span>
      <div [class]="layoutService.isTabletDownView.value ? 'student-spaces-sp' : 'student-spaces'">
        @if (displayedSpaces.length > 0) {
          <p>参加しているスペース：</p>
        }
        <div class="spaces">
          @for (space of displayedSpaces; track space) {
            <p>
              <a class="spen-util-link" data-cy="join-space" (click)="onClickSpace(space)">{{ space.name }}</a>
            </p>
          }
          @if (spaceNumberUndisplay > 0 && !isShowMoreSpaces) {
            <p class="show-more-spaces">
              <a (click)="showMoreSpaces()" class="spen-util-link" data-cy="join-space-remain">
                他{{ spaceNumberUndisplay | number }}件<i class="fa fa-chevron-down"></i>
              </a>
            </p>
          }
        </div>
      </div>
    </div>
    <app-tab-view [tabOptions]="tabOptions"></app-tab-view>
    <div class="list-box">
      @switch (currentTab) {
        @case ('timeline') {
          <app-student-timeline [studentId]="studentId"></app-student-timeline>
        }
        @case ('activity_records') {
          <app-student-activity-records [studentId]="studentId"></app-student-activity-records>
        }
        @case ('albums') {
          <app-student-albums [studentId]="studentId"></app-student-albums>
        }
        @case ('unsubmitted_works') {
          <app-student-unsubmitted-works [studentId]="studentId"></app-student-unsubmitted-works>
        }
      }
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
